module.exports = "/_next/static/media/1d907267dd5b214bd6a549603637a3d6.svg";